import React, { useState } from 'react';
import {
  Dropdown,
  DropdownLayoutValueOption,
  FormField,
} from 'wix-style-react';
import { TranslationFunction } from 'react-i18next';

import styles from './Filter.scss';

export type FilterType =
  | 'all'
  | 'published'
  | 'manually saved'
  | 'starred'
  | 'release candidate';

export interface FilterProps {
  t: TranslationFunction;
  hasReleaseCandidate: boolean;
  onChange(filterOption: FilterType): void;
}

export const Filter: React.FC<FilterProps> = ({
  t,
  hasReleaseCandidate,
  onChange,
}) => {
  const [selectedId, setSelectedId] = useState('all');

  const changeFilter = (e: DropdownLayoutValueOption) => {
    setSelectedId(e.id as FilterType);
    onChange(e.id as FilterType);
  };

  const dropdownOptions: DropdownLayoutValueOption[] = [
    { id: 'all', value: t('FILTER_ALL_REVISIONS') },
    { id: 'published', value: t('FILTER_PUBLISHED') },
    { id: 'manually saved', value: t('FILTER_MANUALLY_SAVED') },
    { id: 'starred', value: t('FILTER_STARRED') },
  ];

  if (hasReleaseCandidate) {
    dropdownOptions.push({
      id: 'release candidate',
      value: t('FILTER_RELEASE_CANDIDATE'),
    });
  }

  return (
    <div className={styles.filterRoot}>
      <FormField label={t('SHOW')} labelPlacement="left">
        <Dropdown
          data-hook="revision-filter"
          selectedId={selectedId}
          disableEditing={true}
          autoSelect={false}
          options={dropdownOptions}
          onSelect={changeFilter}
        />
      </FormField>
    </div>
  );
};
